import './App.css';
import {Route, Routes} from 'react-router-dom'
import Home from './pages/home/Home'
import DynamicRoute from './pages/dynamicRoute/DynamicRoute'
import P from './pages/p/P'


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/p/images' element={<P />} />
        <Route path='/:slug' element={<DynamicRoute />} />
      </Routes>
    </div>
  );
}

export default App;